import { render } from "./Detail.vue?vue&type=template&id=9c94ff64"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
script.render = render

export default script